import { createContext, useContext, type ReactNode } from 'react';

const StaggerBaseIndexContext = createContext(0);

export const useStaggerBaseIndex = () => useContext(StaggerBaseIndexContext);

interface StaggerGroupProps {
  /**
   * Base offset added to the `index` of every {@link StaggerItem} inside. Lets a
   * block cascade *after* an earlier sequence (e.g. a section's content starting
   * after the two-slot header) while its items keep passing local indices from 0.
   */
  startIndex: number;
  children: ReactNode;
}

export const StaggerGroup = ({ startIndex, children }: StaggerGroupProps) => (
  <StaggerBaseIndexContext.Provider value={startIndex}>{children}</StaggerBaseIndexContext.Provider>
);
